/**
 * Right-aligned drawer for filtering nearby people by shared desire tags.
 * Selection is capped at 15 and uses OR semantics on the server (`matches
 * any`). Pure presentational — parent owns `catalog` + `selected`.
 */
const MAX_TAGS = 15;

export default function NearbyDesireDrawer({ catalog, selected, onChange, onClose }) {
  const toggle = (tag) => {
    if (selected.includes(tag)) {
      onChange(selected.filter((t) => t !== tag));
      return;
    }
    if (selected.length >= MAX_TAGS) return;
    onChange([...selected, tag]);
  };

  return (
    <div
      className="pointer-events-auto absolute top-16 right-4 z-[1250] w-80 max-w-[92vw] bg-zinc-950/95 border border-white/10 rounded-2xl backdrop-blur-md shadow-2xl p-4"
      data-testid="nearby-desires-drawer"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="font-display text-lg text-white">✨ Filter by desires</div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="text-zinc-500 hover:text-white"
        >
          ✕
        </button>
      </div>
      <div className="text-[10px] uppercase tracking-widest text-zinc-500 mb-2 flex items-center justify-between">
        <span>{selected.length}/{MAX_TAGS} selected · matches any</span>
        {selected.length > 0 && (
          <button
            type="button"
            onClick={() => onChange([])}
            className="text-rose-400 hover:text-rose-300 normal-case"
            data-testid="nearby-desires-clear"
          >
            Clear all
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-1.5 max-h-72 overflow-y-auto" data-testid="nearby-desires-picker">
        {catalog.map((tag) => {
          const active = selected.includes(tag);
          return (
            <button
              key={tag}
              type="button"
              onClick={() => toggle(tag)}
              data-testid={`nearby-desire-${tag.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${
                active
                  ? "bg-rose-600 border-rose-600 text-white"
                  : "bg-black/40 border-white/10 text-zinc-300 hover:border-white/25 hover:text-white"
              }`}
            >
              {tag}
            </button>
          );
        })}
      </div>
    </div>
  );
}
